export default __webpack_public_path__ + "static/media/product-deliverd.45c6e930.svg";